// Registry of colormaps available for the dedicated VR volume view.
// Two entry types:
// - "preset": diglettk vtk preset LUT driven by the Piecewise Gaussian widget
// - "custom": hardcoded clinical transfer functions (WW/WL applied directly
//   on the transfer functions, PGwidget hidden)
import vrClinicalColormaps from "./vrClinicalColormaps.json";

const presetColormaps = [
  {
    id: "MuscleBone",
    name: "MuscleBone",
    type: "preset",
    preset: "MuscleBone",
    rescaleLUT: true
  }
];

// Custom clinical colormaps exposed in the selector. The full list lives in
// vrClinicalColormaps.json: uncomment an id here to expose it in the UI.
const ENABLED_CUSTOM_COLORMAP_IDS = [
  // "Abdominal",
  // "AirColon",
  // "Angio1",
  // "Angio2",
  "Aorta"
  // "Bone1",
  // "Bone2",
  // "Bone3",
  // "BoneWithPlate",
  // "Cardio",
  // "Cerebral",
  // "Color on DICOM WL",
  // "Color on Data Range",
  // "Epidermis",
  // "Fracture",
  // "Gray",
  // "Gray10",
  // "Gray25",
  // "Gray50",
  // "Hardware",
  // "Hip",
  // "Liver",
  // "MR-Active",
  // "MR-High Range",
  // "MR-Low Range",
  // "MR-Mid Range",
  // "Neck",
  // "Pulmonary",
  // "Renals-Stomach",
  // "Run-off",
  // "XA Cerebral 1",
  // "XA Cerebral 2"
];

const customColormaps = vrClinicalColormaps
  .filter(({ id }) => ENABLED_CUSTOM_COLORMAP_IDS.includes(id))
  .map(({ id, name, colormapCurves }) => ({
    id,
    name,
    type: "custom",
    colormapCurves
  }));

export const VR_COLORMAPS = [...presetColormaps, ...customColormaps];

export const DEFAULT_VR_COLORMAP_ID = "MuscleBone";

export const getVrColormapById = id =>
  VR_COLORMAPS.find(entry => entry.id === id) || null;

export const isVrColormapId = id => getVrColormapById(id) !== null;
